var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagCernaHora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3223_18122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.9999C24 7.88146 21.9249 4.24799 18.7635 2.08691H5.23655C2.07516 4.24799 0 7.88146 0 11.9999C0 16.1185 2.07516 19.7519 5.23655 21.913H18.7635C21.9249 19.7519 24 16.1185 24 11.9999Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39062 8.86954H14.608V6.78262L13.5645 7.30434L11.9993 5.73914L10.4341 7.30434L9.39062 6.78262V8.86954Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6961 12H14.0884C14.1907 11.823 14.2501 11.6183 14.2501 11.3993C14.2501 10.7343 13.711 10.1953 13.0461 10.1953C12.5867 10.1953 12.1877 10.4527 11.9846 10.831C11.7816 10.4527 11.3826 10.1953 10.9232 10.1953C10.2583 10.1953 9.71917 10.7343 9.71917 11.3993C9.71917 11.6184 9.7787 11.8231 9.88089 12H7.30469C7.30469 12.7979 7.9997 13.4447 8.79761 13.4447H8.74952C8.74952 14.0992 9.18484 14.6519 9.7817 14.8294L8.60903 16.0022L9.7158 17.109L11.2858 15.539C11.3473 15.5615 11.4109 15.5795 11.4767 15.5919L10.528 17.7338C10.9826 17.9187 11.4794 18.0213 12.0004 18.0213C12.5214 18.0213 13.0182 17.9187 13.4729 17.7338L12.5242 15.5919C12.5899 15.5796 12.6535 15.5615 12.715 15.539L14.285 17.109L15.3917 16.0022L14.219 14.8295C14.8158 14.6519 15.2512 14.0993 15.2512 13.4448H15.203C16.001 13.4447 16.6961 12.7979 16.6961 12V12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 12.7826L10.3047 13.5652V15.1304L12.0003 16.1739L13.696 15.1304V13.5652L12.0003 12.7826Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 12H13.696V14.087H10.3047V12Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3223_18122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagCernaHora);
export default __webpack_public_path__ + "static/media/icon_flag_cerna_hora.ec1f104b3a9c3e634c56fd6609f3cff6.svg";
export { ForwardRef as ReactComponent };